export function OperatorIdLabel({ countryCode }: { countryCode?: string }) {
  const code = (countryCode || '').toUpperCase()
  switch (code) {
    case 'CN':
      return (
        <>
          Unified Social Credit Code (USCC) <em>统一社会信用代码</em>
        </>
      )
    case 'IN':
      return (
        <>
          Corporate Identification Number (CIN) or Limited Liability Partnership Identification Number (LLPIN)
        </>
      )
    case 'GB':
      return <>Company Registration Number (CRN)</>
    case 'US':
      return <>Central Index Key (CIK)</>
    case 'KR':
      return (
        <>
          Business Registration Number (TIN/BRN) <em>사업자등록번호</em>
        </>
      )
    case 'TR':
      return (
        <>
          Tax Identification Number <em>Vergi Kimlik Numarası (VKN)</em>
        </>
      )
    case 'UA':
      return (
        <>
          Registration number: EDRPOU <em>ЄДРПОУ</em>
        </>
      )
    default:
      return (
        <>
          Business or trade register number, tax identification number or Legal Entity Identifier (LEI)
        </>
      )
  }
} 